import './css/YuesaoSchedule.css'

import { useEffect, useMemo, useState } from "react"
import { Input, Button, Select, DatePicker, message, Space } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Option } = Select

type fetchParams = {
    store_id: undefined | string,
    date: any,
    user_name: string | undefined,
    phone: string | undefined,
    work_years_type: number | undefined,
    star_level_id: string | undefined
}

type starLevelRecord = {
    star_level_id: string
    star_level_name: string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        date: null,
        user_name: undefined,
        phone: undefined,
        work_years_type: undefined,
        star_level_id: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)

    // 日期表头
    const [columnsList, setColumnsList] = useState([])
    // 内容信息
    const [infoData, setInfoData] = useState([])

    const [starLevelList, setStarLevelList] = useState<starLevelRecord[]>([])

    // 页面权限
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        // 查询标准星级列表
        baseAxiosNoInfo.get("/yuesao_center/global/star_level_list", {

        }).then((res: any) => {
            res && setStarLevelList(res)
        })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        setColumnsList([])
        setInfoData([])

        fetch({ fetchOtherParams })
    }

    const fetch = ({ fetchOtherParams }: { fetchOtherParams: object }) => {

        let params: any = { ...fetchOtherParams }

        if (!params.store_id) {
            return message.error('请选择要查询的门店')
        }

        if (params.date) {
            params.date = moment(params.date).format('YYYY-MM')

        } else {
            return message.error('请选择要查询的月份')
        }

        axiosTable.get('/yuesao_center/manage/schedule/list', {
            params: {
                ...params
            }

        }).then((response: any) => {
            if (response) {
                const { date_list, info_data } = response
                const star_level_list: any = info_data.star_level_list

                setColumnsList(date_list)

                if (star_level_list && star_level_list.length > 0) {
                    let typeList = star_level_list

                    for (let i = 0; i < typeList.length; i++) {
                        let personList = typeList[i].person_list

                        for (let j = 0; j < personList.length; j++) {
                            let personDetailList = typeList[i].person_list[j].person_detail_list

                            for (let k = 0; k < personDetailList.length; k++) {
                                personDetailList[k].startNum = personDetailList[k].service_start_date.slice(8) // 截取开始日期
                                personDetailList[k].endNum = personDetailList[k].service_end_date.slice(8) // 截取结束日期
                                personDetailList[k].isOneDay = personDetailList[k].startNum == personDetailList[k].endNum ? true : false

                                switch (personDetailList[k].service_status) {
                                    case 1:
                                        personDetailList[k].className = 'yyd'
                                        break;
                                    case 2:
                                        personDetailList[k].className = 'yrz'
                                        break;
                                    case 3:
                                        personDetailList[k].className = 'ycs'
                                        break;
                                    default:
                                        personDetailList[k].className = 'kf'
                                }
                            }
                        }
                    }

                    setInfoData(typeList)
                }
            }
        })
    }

    const resetForm = () => {
        setColumnsList([])
        setInfoData([])

        setFetchOtherParams(fetchOtherParamsTmpl)
    }

    // 导出
    const exportExcel = () => {
        let params: any = { ...fetchOtherParams }

        if (!params.store_id) {
            return message.error('请选择要查询的门店')
        }

        if (params.date) {
            params.date = moment(params.date).format('YYYY-MM')

        } else {
            return message.error('请选择要查询的月份')
        }

        baseAxiosComplete('/yuesao_center/manage/schedule/export', {
            params: {
                ...params
            }
        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂档期 */}
        <BreadCrumb position={['月嫂中心', '月嫂档期']} />

        {/* 页面筛选 */}
        <div className="common-top-form">
            <Space direction="horizontal" wrap >
                <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="服务门店" value={fetchOtherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
                </div>
                <DatePicker style={{ marginRight: 8, marginBottom: 12 }} className="fl" placeholder={'选择日期'} picker="month" value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工名称" value={fetchOtherParams.user_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'user_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工手机号" value={fetchOtherParams.phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} />

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 100 }} placeholder="工作经验" value={fetchOtherParams.work_years_type} onChange={(value: number) => { handleChange(value, 'work_years_type') }}>
                    <Option value={1} key="1">0年</Option>
                    <Option value={2} key="2">1年</Option>
                    <Option value={3} key="3">2年</Option>
                    <Option value={4} key="4">3年</Option>
                    <Option value={5} key="5">4年</Option>
                    <Option value={6} key="6">5年</Option>
                    <Option value={7} key="7">6年</Option>
                    <Option value={8} key="8">7年</Option>
                    <Option value={9} key="9">8年</Option>
                    <Option value={10} key="10">9年</Option>
                    <Option value={11} key="11">10年</Option>
                    <Option value={12} key="12">10年以上</Option>
                </Select>
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="标准星级" value={fetchOtherParams.star_level_id} onChange={(value: string) => { handleChange(value, 'star_level_id') }}  >
                    {starLevelList.map((el: any) => (<Option value={el.star_level_id} key={el.star_level_id}>{el.star_level_name}</Option>))}
                </Select>
            </Space>

            <div style={{ marginTop: 5 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && (<Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>)}
            </div>
        </div>

        <div className="common-main schedule-data-cont" style={{ marginTop: '10px' }}>
            <div className="clear types">
                <div className="fl clear" style={{ paddingLeft: '16px' }}>
                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl" style={{ marginRight: 4, width: 20, height: 20, background: '#fff', border: '1px solid hwb(216deg 83% 13%)' }}></div>
                        <span className="fl">待岗</span>
                    </div>

                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl yyd" style={{ marginRight: 4, width: 20, height: 20 }}></div>
                        <span className="fl">已预订</span>
                    </div>

                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl yrz" style={{ marginRight: 4, width: 20, height: 20 }}></div>
                        <span className="fl">服务中</span>
                    </div>

                    <div className="fl" style={{ marginRight: 30, marginTop: 5 }}>
                        <div className="secs fl ycs" style={{ marginRight: 4, width: 20, height: 20 }}></div>
                        <span className="fl">已完成</span>
                    </div>
                </div>
            </div>

            {/* 主体内容 */}
            {(columnsList && columnsList.length > 0) && (
                <div className="container">
                    <div className="top-header" style={{ width: `${100 * columnsList.length}px` }}>
                        <span className="top-left">月嫂星级</span>
                        <div className="top-date-box" style={{ width: `${100 * columnsList.length}px` }}>
                            {
                                columnsList.map((el: any) => {
                                    return <div className="top-date" key={el.render_date}>
                                        <div>{el.render_date}</div>
                                        <div>{el.render_date_week}</div>
                                    </div>
                                })
                            }
                        </div>
                    </div>

                    <div className="center-body">
                        {
                            infoData.map((el: any) => {
                                return (
                                    <div className="body-box" style={{ width: `${(100 * columnsList.length) + 100}px` }} key={el.star_level_id}>
                                        <div className="body-line body-line-title body-line-item">
                                            <div className="body-line-text item-text">{el.star_level_name}</div>
                                        </div>
                                        {
                                            el.person_list.map((el2: any) => {
                                                return (
                                                    <div className="body-line-main body-line-item" key={el2.employee_id}>
                                                        <div className="body-line-num item-text">{el2.employee_name}</div>
                                                        {el2.person_detail_list.map((el3: any, index3: any) =>
                                                            <div
                                                                key={index3}
                                                                style={{
                                                                    width: (el3.service_days) * 100,
                                                                    height: '60px',
                                                                    lineHeight: '60px',
                                                                    left: ((el3.date_index) * 100) + 100,
                                                                    borderBottom: '1px solid #d4dbe3'
                                                                }}
                                                                className={"user-room-data fl " + el3.className}
                                                                title={el3.customer_name}
                                                            >
                                                                {el3.customer_name}
                                                            </div>)
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            )}
            {/* 主体内容 */}
        </div>
    </div>)
}